module.exports = __webpack_public_path__ + "img/search.3a7c4847.svg";